(function () {
  function goToPage(upsell, newPage) {
    var pageCount = parseInt(upsell.dataset.pageCount, 10);
    if (newPage < 1) newPage = pageCount;
    if (newPage > pageCount) newPage = 1;

    upsell.querySelectorAll('.cart-upsell__page').forEach(function (page) {
      page.classList.toggle('is-active', parseInt(page.dataset.page, 10) === newPage);
    });

    var currentEl = upsell.querySelector('.cart-upsell__current');
    if (currentEl) currentEl.textContent = newPage;

    upsell.dataset.page = newPage;
  }

  document.addEventListener('click', function (e) {
    // Pagination
    var prevBtn = e.target.closest('.cart-upsell__prev');
    var nextBtn = e.target.closest('.cart-upsell__next');
    if (prevBtn || nextBtn) {
      var upsell = document.getElementById('CartUpsell');
      if (!upsell) return;
      var current = parseInt(upsell.dataset.page, 10);
      goToPage(upsell, prevBtn ? current - 1 : current + 1);
      return;
    }

    // Add to cart
    var addBtn = e.target.closest('.cart-upsell__add');
    if (!addBtn || addBtn.disabled) return;

    var item = addBtn.closest('.cart-upsell__item');
    if (!item) return;

    var variantInput = item.querySelector('.cart-upsell__variant-select');
    var variantId = variantInput ? parseInt(variantInput.value, 10) : 0;
    if (!variantId) return;

    var originalText = addBtn.textContent.trim();
    addBtn.disabled = true;
    addBtn.textContent = '...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) {
          console.error('Upsell add to cart error:', data.description);
          addBtn.disabled = false;
          addBtn.textContent = originalText;
          return;
        }
        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents(data);
        }
      })
      .catch(function (err) {
        console.error('Upsell add to cart failed:', err);
        addBtn.disabled = false;
        addBtn.textContent = originalText;
      });
  });
})();
